/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Button } from "@mui/material";

export const ModalCancelButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "height",
})(({ height }) => ({
  '&:hover': {
    backgroundColor: '#e0e0e0',
  },
  fontSize: '13px',
  textTransform: 'none',
  borderRadius: '8px',
  fontWeight: '600',
  color: '#395bbd',
  height: height || '35px',
  padding: '0px 15px',
}))
